import React from 'react';

import useStyles from './styles';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "../../Tooltip";
import {BcaDeleteIcon, BcaEditIcon} from "../../../images/BcaIcon";
import {mergeClasses} from "@material-ui/styles";


export const BcaIconButtonTooltip = ({tooltip, children, interactive=false}) => {
  if (!tooltip) {
    return children;
  }

  return (
    <Tooltip title={tooltip} placement="top" width={600} interactive={interactive}>
      <span>{children}</span>
    </Tooltip>
  )
};


function BcaIconButton({icon, tooltip, variant, color, onClick, disabled, fontSize, interactive, ...props}) {

  const classes = useStyles({fontSize: fontSize});

  return (
    <BcaIconButtonTooltip tooltip={tooltip} interactive={interactive}>
      <IconButton
        color={color}
        aria-label="close"
        onClick={onClick}
        classes={mergeClasses({
          baseClasses: {root: classes.root, disabled: classes.disabled},
          newClasses: props.customClasses,
          Component: IconButton
        })}
        disabled={disabled}
      >
        {icon}
      </IconButton>
    </BcaIconButtonTooltip>
  )
}

BcaIconButton.propTypes = {};

BcaIconButton.propDefs = {};

BcaIconButton.defaultProps = {
  color: 'primary',
  fontSize: 16,
};

export function BcaDeleteIconButton({onClick, disabled, color, fontSize, tooltip="Löschen"}) {
  return (
    <BcaIconButton tooltip={tooltip} disabled={disabled} icon={<BcaDeleteIcon />} onClick={onClick} color={color} fontSize={fontSize}/>
  )
}

export function BcaEditIconButton({onClick, disabled, tooltip="Bearbeiten"}) {
  return (
    <BcaIconButton tooltip={tooltip} disabled={disabled} icon={<BcaEditIcon />} onClick={onClick}/>
  )
}

export default BcaIconButton;